import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setListData } from "src/store/reducers/noticeListReduce";
import { useAppSelector } from "src/store/actions/action";
import DatePicker, { registerLocale } from "react-datepicker";
import moment from "moment";
import ko from "date-fns/locale/ko";
registerLocale("ko", ko);
import Chip from "../common/Chip";
import DatapickerInput from "../common/Datepicker";
import CalendarHeader from "../common/CalendarHeader";
import styled from "styled-components";
import "src/styles/react-datepicker.css";

interface dataProps {
  filterList: any;
  changeChecked?(value: ListFilter, key: string): void;
  setInitFunc?: any;
  stateStartDate?: any;
  stateEndDate?: any;
}

const NoticeFilterItem = (props: dataProps) => {
  const dispatch = useDispatch();
  const noticeListReduce = useAppSelector((state) => state.noticeListReduce);
  const [chipsData, setChipsData] = useState(props.filterList);
  const { typeFilter, dateFilter } = chipsData;

  // Datepicker
  const [isDatePicker, setIsDatePicker] = useState<boolean>(true); // datepicker : disabled = true
  const [startDate, setStartDate] = useState(props.stateStartDate ? new Date(props.stateStartDate) : new Date());
  const [endDate, setEndDate] = useState(props.stateEndDate ? new Date(props.stateEndDate) : new Date());
  const handleCalendarOpen = () => {
    document.addEventListener(
      "touchstart",
      (event: TouchEvent) => {
        event.stopPropagation();
      },
      true,
    );
  };

  useEffect(() => {
    dispatch(
      setListData({
        searchStartDate: moment(startDate).format("YYYY-MM-DD"),
      }),
    );
    const result = new Date(endDate);
    result.setDate(result.getDate() + 1);
    dispatch(setListData({ searchEndDate: moment(result).format("YYYY-MM-DD") }));
  }, [startDate, endDate]);

  useEffect(() => {
    if (noticeListReduce.typeSearchArray?.includes("기간선택")) {
      setIsDatePicker(false);
    } else {
      setIsDatePicker(true);
    }
  }, [noticeListReduce]);

  useEffect(() => {
    setChipsData(props.filterList);
  }, [props.filterList]);

  useEffect(() => {
    const getSelectedType = typeFilter.data.filter((v: any) => v.checked === true).map((v: any) => v.type);
    const getSelectedDate = dateFilter.data.filter((v: any) => v.checked === true).map((v: any) => v.type);
    const newChipsData = getSelectedType.concat(getSelectedDate);

    dispatch(
      setListData({
        filterList: chipsData,
        typeSearchArray: newChipsData,
      }),
    );
  }, [chipsData]);

  const changeChecked = (value: any) => {
    if (typeFilter.data.includes(value)) {
      // 토글, 중복선택O
      const getSelectedType = typeFilter.data.map((v: any) => (v.type === value.type ? { ...v, checked: !v.checked } : { ...v, checked: v.checked }));
      setChipsData({
        ...chipsData,
        typeFilter: {
          ...typeFilter,
          data: getSelectedType,
        },
      });
    }
    if (dateFilter.data.includes(value)) {
      // 토글, 중복선택X
      const getSelectedDate = dateFilter.data.map((v: any) => (v.type === value.type ? { ...v, checked: !v.checked } : { ...v, checked: false }));
      setChipsData({
        ...chipsData,
        dateFilter: {
          ...dateFilter,
          data: getSelectedDate,
        },
      });

      if (value.type === "기간선택") {
        setIsDatePicker(false);
      } else {
        setIsDatePicker(true);
      }
    }
  };

  return (
    <>
      <FilterItemSet>
        <p className="title">선택한 조건</p>
        <div>
          {typeFilter.data.map((value: ListFilter, index: number) => {
            return (
              value.checked && (
                <Chip variant="contained" key={index} deleted={true} onDelete={() => changeChecked(value)}>
                  {value.type}
                </Chip>
              )
            );
          })}
          {dateFilter.data.map((value: ListFilter, index: number) => {
            return (
              value.checked && (
                <Chip variant="contained" key={index} deleted={true} onDelete={() => changeChecked(value)}>
                  {value.type}
                </Chip>
              )
            );
          })}
        </div>
      </FilterItemSet>
      <FilterItemSet>
        <p className="title">{typeFilter.title}</p>
        <div>
          {typeFilter &&
            typeFilter.data.map((value: ListFilter, index: number) => {
              return (
                <Chip variant="outlined" selected={value.checked} key={index} onClick={(e) => changeChecked(value)}>
                  {value.type}
                </Chip>
              );
            })}
        </div>
      </FilterItemSet>
      <FilterItemSet>
        <p className="title">{dateFilter.title}</p>
        <div>
          {dateFilter &&
            dateFilter.data.map((value: ListFilter, index: number) => {
              return (
                <Chip variant="outlined" selected={value.checked} key={index} onClick={(e) => changeChecked(value)}>
                  {value.type}
                </Chip>
              );
            })}
          <DatePickerWrap style={{ background: isDatePicker ? "#f4f5f7" : "" }}>
            <DatePicker
              locale={ko}
              disabled={isDatePicker}
              selected={startDate}
              onChange={(date: any) => setStartDate(date)}
              selectsStart
              startDate={startDate}
              endDate={endDate}
              maxDate={new Date()}
              withPortal
              onCalendarOpen={handleCalendarOpen}
              renderCustomHeader={({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => (
                <CalendarHeader
                  data={{
                    date,
                    changeYear,
                    changeMonth,
                    decreaseMonth,
                    increaseMonth,
                    prevMonthButtonDisabled,
                    nextMonthButtonDisabled,
                  }}
                />
              )}
              customInput={<DatapickerInput defaultValue={moment(startDate).format("YYYY.MM.DD")} />}
            />
            <span className="divide"></span>
            <DatePicker
              locale={ko}
              disabled={isDatePicker}
              selected={endDate}
              onChange={(date: any) => setEndDate(date)}
              selectsEnd
              startDate={startDate}
              endDate={endDate}
              // minDate={startDate}
              maxDate={new Date()}
              withPortal
              onCalendarOpen={handleCalendarOpen}
              renderCustomHeader={({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => (
                <CalendarHeader
                  data={{
                    date,
                    changeYear,
                    changeMonth,
                    decreaseMonth,
                    increaseMonth,
                    prevMonthButtonDisabled,
                    nextMonthButtonDisabled,
                  }}
                />
              )}
              customInput={<DatapickerInput defaultValue={moment(endDate).format("YYYY.MM.DD")} />}
            />
          </DatePickerWrap>
        </div>
      </FilterItemSet>
    </>
  );
};

const FilterItemSet = styled.li`
  .title {
    font-size: 16px;
    font-weight: 500;
  }
  > div {
    ${({ theme }) => theme.flexBox.flexMixin("row", "flex-start", "center", "wrap")}
    > div {
      margin: 15px 10px 0 0;
    }
  }
`;

const DatePickerWrap = styled.div`
  overflow: hidden;
  width: auto;
  max-width: 345px;
  ${({ theme }) => theme.flexBox.flexMixin("row", "flex-start")}
  border: 1px solid ${({ theme }) => theme.color.lineSecondary};
  border-radius: 14px;
  padding: 0 15px;
  > .react-datepicker-wrapper {
    width: 120px;
  }
  .divide {
    position: relative;
    display: block;
    height: 28px;
    width: 20px;
    padding: 0 10px;
    margin-right: 15px;
    flex: 1;
    &::before {
      position: absolute;
      left: 0;
      top: 50%;
      content: "";
      display: block;
      width: 20px;
      height: 1px;
      background-color: ${({ theme }) => theme.color.lineSecondary};
    }
  }
`;

export default NoticeFilterItem;
